import { MultiSelect } from "@/components/ui/FormFields/MultiselectFormField/MultiselectFormField";
import { retrieveMatterSettingsQueryOptions } from "@/lib/data/react-query";
import { getIncidentTypeLabel } from "@/lib/utils/matters/incident-classification";
import { useQuery } from "@tanstack/react-query";

export function IncidentTypeFilter({
  value,
  onChange,
}: {
  value: string[];
  onChange: (value: string[]) => void;
}) {
  const { data, isLoading, isError } = useQuery(
    retrieveMatterSettingsQueryOptions(),
  );
  return (
    <div>
      <MultiSelect
        aria-label="Incident types"
        placeholder="Incident types"
        options={(data?.data.incidentTypes ?? []).map((type) => ({
          value: type.id,
          label: getIncidentTypeLabel(type),
        }))}
        selectedValues={value}
        setSelectedValues={() => {}}
        onValueChange={onChange}
        isLoading={isLoading}
        disabled={isError}
        ignoreAllSelected
      />
      {isError && (
        <p role="alert" className="text-destructive text-sm">
          Incident types could not be loaded.
        </p>
      )}
    </div>
  );
}
